import _Object$keys from "@babel/runtime-corejs3/core-js-stable/object/keys";
import _Object$getOwnPropertySymbols from "@babel/runtime-corejs3/core-js-stable/object/get-own-property-symbols";
import _filterInstanceProperty from "@babel/runtime-corejs3/core-js-stable/instance/filter";
import _Object$getOwnPropertyDescriptor from "@babel/runtime-corejs3/core-js-stable/object/get-own-property-descriptor";
import _forEachInstanceProperty from "@babel/runtime-corejs3/core-js-stable/instance/for-each";
import _Object$getOwnPropertyDescriptors from "@babel/runtime-corejs3/core-js-stable/object/get-own-property-descriptors";
import _Object$defineProperties from "@babel/runtime-corejs3/core-js-stable/object/define-properties";
import _Object$defineProperty from "@babel/runtime-corejs3/core-js-stable/object/define-property";
import _defineProperty from "@babel/runtime-corejs3/helpers/defineProperty";
import _concatInstanceProperty from "@babel/runtime-corejs3/core-js-stable/instance/concat";
function ownKeys(e, r) { var t = _Object$keys(e); if (_Object$getOwnPropertySymbols) { var o = _Object$getOwnPropertySymbols(e); r && (o = _filterInstanceProperty(o).call(o, function (r) { return _Object$getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var _context3, _context4; var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? _forEachInstanceProperty(_context3 = ownKeys(Object(t), !0)).call(_context3, function (r) { _defineProperty(e, r, t[r]); }) : _Object$getOwnPropertyDescriptors ? _Object$defineProperties(e, _Object$getOwnPropertyDescriptors(t)) : _forEachInstanceProperty(_context4 = ownKeys(Object(t))).call(_context4, function (r) { _Object$defineProperty(e, r, _Object$getOwnPropertyDescriptor(t, r)); }); } return e; }
import "core-js/modules/es.string.small.js";
import React from "react";
import { RaiseColors } from "componentLibrary/theme/RaiseColors";
import { CustomRaiseTypography } from "componentLibrary/theme/RaiseTypography";
import styles from "./badge.module.scss";
import { colorVariablesFormat } from "utils/stringUtils";
// please refer to the following link for the button you are looking for
// https://www.figma.com/design/yg7J0qZnn7wX9fLBBYgVdy/Responsive---Design-System?node-id=5339-6143&m=dev
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
export var BadgeVariantEnum = /*#__PURE__*/function (BadgeVariantEnum) {
  BadgeVariantEnum["filled"] = "filled";
  BadgeVariantEnum["accent"] = "accent";
  BadgeVariantEnum["outlined"] = "outlined";
  return BadgeVariantEnum;
}({});
export var BadgeTypeEnum = /*#__PURE__*/function (BadgeTypeEnum) {
  BadgeTypeEnum["primary"] = "primary";
  BadgeTypeEnum["neutral"] = "neutral";
  BadgeTypeEnum["success"] = "success";
  BadgeTypeEnum["warning"] = "warning";
  BadgeTypeEnum["destructive"] = "destructive";
  BadgeTypeEnum["royal"] = "royal";
  BadgeTypeEnum["amber"] = "amber";
  BadgeTypeEnum["bahama"] = "bahama";
  BadgeTypeEnum["lilac"] = "lilac";
  return BadgeTypeEnum;
}({});
export var BadgeSizeEnum = /*#__PURE__*/function (BadgeSizeEnum) {
  BadgeSizeEnum["large"] = "large";
  BadgeSizeEnum["medium"] = "medium";
  BadgeSizeEnum["small"] = "small";
  return BadgeSizeEnum;
}({});
var getBadgeColorVariables = function getBadgeColorVariables(type, variant) {
  if (type === BadgeTypeEnum.primary) {
    return colorVariablesFormat(RaiseColors.science900, RaiseColors.science200);
  } else if (type === BadgeTypeEnum.neutral) {
    return colorVariablesFormat(RaiseColors.glacier2400, RaiseColors.glacier2300);
  } else if (type === BadgeTypeEnum.success) {
    // filled should use salem900 per design; outlined/accent keep existing
    return variant === BadgeVariantEnum.filled ? colorVariablesFormat(RaiseColors.salem900, RaiseColors.salem100) : colorVariablesFormat(RaiseColors.salem1200, RaiseColors.salem100);
  } else if (type === BadgeTypeEnum.warning) {
    return colorVariablesFormat(RaiseColors.orange900, RaiseColors.orange100);
  } else if (type === BadgeTypeEnum.destructive) {
    return colorVariablesFormat(RaiseColors.crimson1400, RaiseColors.crimson100);
  } else if (type === BadgeTypeEnum.royal) {
    return colorVariablesFormat(RaiseColors.royal1500, RaiseColors.royal200);
  } else if (type === BadgeTypeEnum.amber) {
    // filled should use amber500 per design; outlined/accent keep existing
    return variant === BadgeVariantEnum.filled ? colorVariablesFormat(RaiseColors.amber500, RaiseColors.amber200) : colorVariablesFormat(RaiseColors.amber900, RaiseColors.amber200);
  } else if (type === BadgeTypeEnum.lilac) {
    return colorVariablesFormat(RaiseColors.lilac1500, RaiseColors.lilac200);
  } else if (type === BadgeTypeEnum.bahama) {
    return colorVariablesFormat(RaiseColors.bahama1200, RaiseColors.bahama200);
  }
  // Fallback to neutral for any unsupported/undefined type or variant
  return colorVariablesFormat(RaiseColors.glacier2400, RaiseColors.glacier2300);
};
var getTypography = function getTypography(size) {
  switch (size) {
    case BadgeSizeEnum.large:
      return CustomRaiseTypography.paragraph_small;
    case BadgeSizeEnum.medium:
      return CustomRaiseTypography.paragraph_small;
    case BadgeSizeEnum.small:
      return CustomRaiseTypography.paragraph_xsmall;
    default:
      throw new Error("unsupported badge size");
  }
};
var RaiseBadge = function RaiseBadge(_ref) {
  var _context, _context2;
  var variant = _ref.variant,
    type = _ref.type,
    size = _ref.size,
    leadingIcon = _ref.leadingIcon,
    trailingIcon = _ref.trailingIcon,
    colorVariable = _ref.colorVariable,
    children = _ref.children;
  var textTypography = getTypography(size);
  var badgeColorVariables = !colorVariable ? getBadgeColorVariables(type, variant) : colorVariable;
  return /*#__PURE__*/_jsxs("span", {
    style: _objectSpread(_objectSpread({}, badgeColorVariables), textTypography),
    className: _concatInstanceProperty(_context = _concatInstanceProperty(_context2 = "".concat(styles.base, " ")).call(_context2, styles["".concat(variant)], " ")).call(_context, styles["".concat(size)]),
    children: [leadingIcon ? /*#__PURE__*/_jsx("span", {
      className: leadingIcon
    }) : null, children, trailingIcon ? /*#__PURE__*/_jsx("span", {
      className: trailingIcon
    }) : null]
  });
};
export default RaiseBadge;